"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
function extractFieldMappingNodeId(value) {
    return lodash_1.isString(value) && lodash_1.get(value.match(/\{\{([0-9]*)__.*\}\}/), [1]);
}
exports.default = extractFieldMappingNodeId;
